<template>
  <a-modal
    :visible="visible"
    :title="title"
    :getContainer="false"
    width="50%"
    @cancel="handleCancel"
  >
    <div class="cont">
      <p style="font-size: 18px;">匹配完成</p>
      <p>匹配成功{{ data.success_num }}条，匹配失败{{ data.fail_num }}条</p>
      <p v-if="data.fail_num > 0">
        匹配失败文件：<a :href="data.fail_file_url" target="_blank">{{ data.fail_file_url }} </a>
      </p>
    </div>
    <template #footer>
      <div style="text-align: center;">
        <a-button key="back" @click="handleCancel" type="primary">确定</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import API from "./api";

export default {
  name: "importTranslationFinishModal",
  props: {
    title: {
      type: String,
      default: "完成"
    }
  },
  data() {
    return {
      data: {},
      visible: false
    };
  },
  mounted() {},
  methods: {
    open(data) {
      this.data = data;
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
      this.$emit("changVisible");
    }
  }
};
</script>

<style scoped>
.cont {
  text-align: center;
}
</style>
